import React from "react";
import { Box, Typography } from "@mui/material";
import { keyframes } from "@mui/system";
import bgimg from "../../images/cuisin.jpg"; // Correctly importing the image



function Cuisin() {
  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        height: "400px", // Adjust height as needed
        backgroundImage: `url(${bgimg})`, // Correctly using the imported image
        backgroundSize: "cover",
        backgroundPosition: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {/* Overlay */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.5)", // Black overlay with 50% opacity
          zIndex: 1,
        }}
      />

      {/* Text Content */}
      <Box
        sx={{
          position: "relative",
          textAlign: "center",
          zIndex: 2,
          color: "white",
        }}
      >
        <Typography
          variant="overline"
          sx={{
            fontSize: "14px",
            textTransform: "uppercase",
            letterSpacing: "2px",
            color: "#f3f3f3",
          }}
        >
          Curated Culinary Experiences
        </Typography>
        <Typography
          variant="h2"
          sx={{
            fontSize: "48px",
            fontWeight: "bold",
            margin: "10px 0",
            fontFamily: "Georgia, serif",
          }}
        >
          Cuisine
        </Typography>
        <Typography
          variant="body1"
          sx={{
            fontSize: "18px",
            fontWeight: "300",
            color: "#e0e0e0",
          }}
        >
          Enjoy a various amount of dining options from around the world.
        </Typography>
      </Box>
    </Box>
  );
}

export default Cuisin;
